import { CheckboxCustomEvent, IonCheckbox, IonItem, IonLabel } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { debug } from "../../App";

export default function Checkbox(props: any) {
  const { name, onIonChange, value } = props;
  const [currentValue, setCurrentValue] = useState<null | { [key: string]: any }>(value);

  useEffect(() => {
    const ionEvent = new CustomEvent("ionChange", {
      detail: {
        name: name,
        value: currentValue,
      },
    });
    debug("Change event", ionEvent, currentValue);
    onIonChange(ionEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  function handleChange(event: CheckboxCustomEvent, option: string) {
    debug("handleChange, currentValue = ", currentValue);
    const tempValue = currentValue === null ? {} : { ...currentValue };
    tempValue[option] = event.detail.checked;

    setCurrentValue(tempValue);
  }

  return (
    <>
      {props.label && <IonLabel>{props.label}</IonLabel>}
      {props.options.map((option: string) => (
        <IonItem className="input__checkbox-wrap" lines="none" key={`option-${option}`}>
          <IonCheckbox
            slot={"start"}
            checked={currentValue !== null && currentValue?.hasOwnProperty(option) && currentValue[option] === true}
            {...props}
            onIonChange={(e: CheckboxCustomEvent) => {
              handleChange(e, option);
            }}
          />
          <IonLabel>{option}</IonLabel>
        </IonItem>
      ))}
    </>
  );
}
